<!--
 * @Author: your name
 * @Date: 2020-11-03 10:25:33
 * @LastEditTime: 2020-11-04 16:28:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \smro_web\src\page\index\logo.vue
-->
<template>
  <div class="avue-logo">
    <transition name="fade">
      <span v-if="keyCollapse" class="avue-logo_subtitle" key="0">
        {{ companyName? companyName.slice(0,2) : website.indexTitle }}
      </span>
    </transition>
    <transition-group name="fade">
      <template v-if="!keyCollapse">
        <span class="avue-logo_title" key="1" v-if="!compayTitle"
          >{{ compayTitle || website.indexTitle }}
        </span>
        <span class="avue-logo_title" key="1" v-if="compayTitle"
          ><img :src="compayTitle" />
        </span>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getTopUrl } from "@/util/util";
import { info } from "@/api/system/tenant";
export default {
  name: "logo",
  data() {
    return {
      compayTitle: "",
      companyName: ''
    };
  },
  created() {},
  computed: {
    ...mapGetters(["website", "keyCollapse"]),
  },
  methods: {},
};
</script>

<style lang="scss">
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-active {
  transition: opacity 2.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.avue-logo {
  position: fixed;
  top: 0;
  left: 0;
  width: 210px;
  height: 64px;
  line-height: 64px;
  background-color: #20222a;
  font-size: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
  color: rgba(255, 255, 255, 0.8);
  z-index: 1024;
  &_title {
    display: block;
    text-align: center;
    font-weight: 300;
    font-size: 20px;
  }
  &_subtitle {
    display: block;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #fff;
  }
  .avue-logo_title{
    height:60px;vertical-align: middle;
    img{height: 50px;margin-top: 8px;;}
  }
}
</style>